import React, { useContext, useRef, useEffect, useState } from 'react';
import { MDForm } from '../../metadata/MDForm';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { DeclaredComponent } from '../../DynamicComponent';
import { ErrorSink } from '../../ErrorSink';
import { getLineProductSetupContext } from '../line/LineForm';
import { StepsValidationStatusContext } from '../../../context/StepsValidationStatusProvider';
import { DriversAndVehiclesDataReportContext } from '../../../context/DriversAndVehiclesDataReportProvider';
import Collapse from 'antd/lib/collapse';
import Icon from 'antd/lib/icon';
import { RemoveBeanBtn } from '../RemoveBeanBtn';
import { ModelContext } from '../../metadata/ModelSource';

const { Panel } = Collapse;

export function RiskListForm({ forms, lineCd, removeCollapse }) {
  const applicationModel = useContext(ModelContext);
  const risks = applicationModel.getValue(`lines{lineCd:${lineCd}}.risks`);

  if (!risks) {
    return null;
  }

  const risksRef = useRef([]);

  const { productSetup } = useContext(ProductInfoContext);
  const { scrollIndex } = useContext(StepsValidationStatusContext);
  const { expandRisks } = useContext(DriversAndVehiclesDataReportContext);
  const [oneRisk, setOneRisk] = useState(true);

  const defaultRiskType = Object.keys(forms)[0];
  const lineProductSetupContext = getLineProductSetupContext(
    productSetup,
    applicationModel,
    lineCd
  );

  const [activeKeys, setActiveKeys] = useState([]);
  const [dataPrefillKeys, setDataPrefillKeys] = useState([]);

  const setActiveRiskKeys = (key)=>{
    if (activeKeys && activeKeys.length === 1){
      if (dataPrefillKeys.length === 0){
        activeKeys[0] === key ? setActiveKeys([]): setActiveKeys(new Array(key));
      }else {
        activeKeys[0] === key ? setActiveKeys([]): setActiveKeys([...activeKeys, key]);
      }
    }else {
      const index = activeKeys.indexOf(key);
      let newActiveKeys = [...activeKeys];
      if(index !== -1){
        newActiveKeys.splice(index,1);
      }else {
        newActiveKeys = [...newActiveKeys, key];
      }
      setActiveKeys(newActiveKeys);
    }
    setDataPrefillRiskKeys(key);
  }

  const setDataPrefillRiskKeys = (key)=>{
    const index = dataPrefillKeys.indexOf(key);
    let keys = [...dataPrefillKeys];
    index !== -1 ? keys.splice(index, 1) : null
    setDataPrefillKeys(keys);
  }

  const getDefaultRiskKeys = ()=>{
    const defaultActiveKeys = [];
    for (let i in risks){
      const d = risks[i];
      if (d.id && d.id.indexOf('Prefill') >= 0 && d.status === 'Active'){
        defaultActiveKeys.push(i.toString())
      }
    }
    return defaultActiveKeys;
  }

  const scrollToDriverRef = ref => {
    window.scrollTo(0, ref.offsetTop);
  };

  useEffect(() => {
    setActiveRiskKeys((risks.length - 1).toString());
  }, [risks.length])

  useEffect(() => {
    const activeRisks = risks.filter(risk => {
      return (risk.status !== 'Deleted');
    });
    const oneDriver = activeRisks.length === 1 ? true : false;
    setOneRisk(oneDriver);
  }, [applicationModel]);

  useEffect(() => {
    if (scrollIndex !== undefined && risksRef.current.length === risks.length) {
      scrollToDriverRef(risksRef.current[scrollIndex]);
      setActiveRiskKeys(scrollIndex.toString())
    }
  }, [scrollIndex]);

  useEffect(() => {
    const defaultActiveKeys = getDefaultRiskKeys()
    if (defaultActiveKeys && defaultActiveKeys.length > 0){
      setActiveKeys(defaultActiveKeys);
    }else {
      const index = (risks.length - 1).toString();
      setActiveRiskKeys(index);
    }
    setDataPrefillKeys(defaultActiveKeys);
  }, [])

  useEffect(() => {
    if (!expandRisks){
      setDataPrefillKeys([]);
      setActiveKeys([(risks.length - 1).toString()]);
    }
  }, [risks.length])

  const Header = ({ risk, riskIndex, lineCd }) => {
    const displayValue = risk.displayDesc;
    let displayLabel = 'Automobile';
    if (displayValue === 'Trailer') {
      displayLabel = displayValue;
    }
    const formPrefix = `lines{lineCd:${lineCd}}.risks[${riskIndex}]`;
    const currentBean = applicationModel.getValue(
      formPrefix.substring(0, formPrefix.lastIndexOf(']') + 1)
    );
    const props = {
      style: {
        marginLeft: 'auto'
      },
      path: `lines{lineCd:${lineCd}}.risks`,
      proto: {
        typeCd: `${defaultRiskType}`
      },
      prefix: formPrefix,
      type: displayValue
    };
    const displayCriteria =
      currentBean.vehicle &&
      currentBean.vehicle.modelYr &&
      currentBean.vehicle.manufacturer &&
      currentBean.vehicle.model;
    const displayText = displayCriteria
      ? `${currentBean.vehicle.modelYr} - ${currentBean.vehicle.manufacturer} ${currentBean.vehicle.model}`
      : '';
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: oneRisk ? 'flex-start' : 'center',
          alignContent: 'center',
          paddingTop: '15px',
          paddingBottom: '15px'
        }}
      >
        <span
          style={{ fontSize: '18px', margin: 0, alignSelf: 'center' }}
          className="bold"
          onClick={() => setActiveRiskKeys(riskIndex.toString())}
        >
          {displayLabel}  {displayText ? `- ${displayText}` : ''}
        </span>
        {oneRisk ? null : <RemoveBeanBtn {...props} vehicle={true} />}
      </div>
    );
  };

  if (removeCollapse === true) {
    return (
      <div>
        {risks.map((risk, i) => {
          // Since risks sent to the api cannot be removed from the application, this will prevent them from showing on the UI
          if (risk.status === 'Deleted') return null;

          const key = risk.id || risk._tempId;

          const form = forms[risk.typeCd];

          if (!form) {
            return (
              <ErrorSink
                key={key}
                message={`form is not defined for risk ${key}`}
              />
            );
          }

          const riskProductSetupContext = getRiskProductSetupContext(
            lineProductSetupContext,
            risk.typeCd
          );

          if (!riskProductSetupContext) {
            throw 'no product setup found for risk type ' + risk.typeCd;
          }
          return (
            <div
              key={key}
              ref={element => {
                risksRef.current[i] = element;
              }}
            >
              <MDForm
                key={key}
                prefix={`lines{lineCd:${lineCd}}.risks[${i}]`}
                model={applicationModel}
                productSetupContext={riskProductSetupContext}
                presentationMetadata={form}
              >
                <DeclaredComponent declaration={form} prefix={`lines{lineCd:${lineCd}}.risks[${i}]`} />
              </MDForm>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <Collapse
      expandIcon={props => {
        const { panelKey, isActive } = props;
        return (
          <Icon
            onClick={() => setActiveRiskKeys(panelKey)}
            type={isActive ? 'down' : 'right'}
          />
        );
      }}
      bordered={false}
      activeKey={activeKeys}
      // defaultActiveKey={'0'}
      accordion={false}
    >
      {risks.map((risk, i) => {
        // Since risks sent to the api cannot be removed from the application, this will prevent them from showing on the UI
        if (risk.status === 'Deleted') return null;

        const key = risk.id || risk._tempId;

        const form = forms[risk.typeCd];

        if (!form) {
          return (
            <ErrorSink
              key={key}
              message={`form is not defined for risk ${key}`}
            />
          );
        }

        const riskProductSetupContext = getRiskProductSetupContext(
          lineProductSetupContext,
          risk.typeCd
        );

        if (!riskProductSetupContext) {
          throw 'no product setup found for risk type ' + risk.typeCd;
        }
        return (
          <Panel
            key={i}
            header={
              <Header
                risk={riskProductSetupContext}
                riskIndex={i}
                lineCd={lineCd}
              />
            }
            className='has-interest-in-panel'
            forceRender={true}
          >
            <div
              key={key}
              ref={element => {
                risksRef.current[i] = element;
              }}
            >
              <MDForm
                key={key}
                prefix={`lines{lineCd:${lineCd}}.risks[${i}]`}
                model={applicationModel}
                productSetupContext={riskProductSetupContext}
                presentationMetadata={form}
              >
                <DeclaredComponent declaration={form} />
              </MDForm>
            </div>
          </Panel>
        );
      })}
    </Collapse>
  );
}

export function getRiskProductSetupContext(
  lineProductSetupContext,
  riskTypeCd
) {
  if (
    !lineProductSetupContext ||
    !lineProductSetupContext.productRiskTypes ||
    !lineProductSetupContext.productRiskTypes.productRiskType
  ) {
    return null;
  }
  return lineProductSetupContext.productRiskTypes.productRiskType.find(
    r => r.riskTypeCd === riskTypeCd
  );
}
